import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faLink, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { createShareLinks } from '../../config';
import '../../styles/modals/AppInviteModal.css';

const AppInviteModal = ({ isOpen, onClose, groupId, groupName }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const inviteUrl = createShareLinks.invite(groupId);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(inviteUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = inviteUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className="app-invite-modal-overlay" onClick={handleOverlayClick}>
      <div className="app-invite-modal" onClick={(e) => e.stopPropagation()}>
        <button className="app-invite-modal-close" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="app-invite-modal-content">
          <div className="app-invite-modal-icon">
            <FontAwesomeIcon icon={faLink} />
          </div>
          
          <h2 className="app-invite-modal-title">Invite your community</h2>
          <p className="app-invite-modal-description">
            Share this link with members to invite them to {groupName || 'your community'}
          </p>

          {/* Share Link Section */}
          <div className="share-link-section">
            <label className="share-link-label">Share page link</label>
            <div className="share-link-container">
              <input
                type="text"
                value={inviteUrl}
                readOnly
                className="share-link-input"
              />
              <button
                onClick={handleCopyLink}
                className={`copy-link-button ${copied ? 'copied' : ''}`}
              >
                {copied ? (
                  <>
                    <FontAwesomeIcon icon={faCheck} />
                    <span>Copied</span>
                  </>
                ) : (
                  <span>Copy</span>
                )}
              </button>
            </div>
          </div>

          {/* Download App Section */}
          <div className="download-app-section">
            <p className="download-app-text">Or invite them to download the app</p>
            
            <div className="download-buttons-horizontal">
              <a
                href="https://apps.apple.com/us/app/yesod/id6748472269"
                target="_blank"
                rel="noopener noreferrer"
                className="download-button-simple ios-button"
              >
                <div className="download-button-icon">
                  <FontAwesomeIcon icon={faApple} />
                </div>
                <div className="download-button-text">
                  <span className="download-button-label">Download on</span>
                  <span className="download-button-store">App Store</span>
                </div>
              </a>
              
              <a
                href="https://play.google.com/store/apps/details?id=us.yesod.app"
                target="_blank"
                rel="noopener noreferrer"
                className="download-button-simple android-button"
              >
                <div className="download-button-icon">
                  <FontAwesomeIcon icon={faGooglePlay} />
                </div>
                <div className="download-button-text">
                  <span className="download-button-label">Get it on</span>
                  <span className="download-button-store">Google Play</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AppInviteModal;